import React from 'react';

import DataTable from '../shared/data_table';
import StatusPill from '../shared/status_pill';
import TeacherSlugLine from '../shared/teacher_slug_line';
import WhyPopover from '../overview/why_popover';

/* saved entries. */
// highlight_uuid: the entry an IDEMPOTENCY_MISMATCH says was already saved — the operator lands on it.
// sort/on_sort: server-side (additional/types.go ListSortKeys) — a header click re-fetches the page.
const EntriesTable = ({ rows, on_edit, on_remove, highlight_uuid, sort, on_sort }) => {
  const actions_cell = (r) => {
    if (r.can_edit || r.can_remove || r.can_waive) {
      return (
        <span className="tp-actions">
          {r.can_edit ? (
            <button type="button" className="tp-link" onClick={() => on_edit(r)}>
              Edit
            </button>
          ) : null}
          {r.can_remove ? (
            <button type="button" className="tp-link" onClick={() => on_remove(r)}>
              Remove
            </button>
          ) : null}
          {r.can_waive ? (
            <button type="button" className="tp-link" onClick={() => on_remove(r)}>
              Waive
            </button>
          ) : null}
        </span>
      );
    }
    return (
      <span className="tp-card-field-label" title={r.why_not}>
        {r.why_not || 'Not editable'}
      </span>
    );
  };

  const columns = [
    {
      key: 'teacher_name',
      label: 'Teacher',
      hideInCard: true,
      sort_key: 'teacher_name',
      render: (r) => (
        <div>
          <div>{r.teacher_name}</div>
          <TeacherSlugLine slug={r.teacher_slug} />
        </div>
      )
    },
    { key: 'month_text', label: 'Month' },
    {
      key: 'category_label',
      label: 'Category',
      sort_key: 'category',
      render: (r) => (
        <span>
          {r.category_label}
          {r.is_system && r.source_month_text ? (
            <span className="tp-card-field-label"> from {r.source_month_text}</span>
          ) : null}
        </span>
      )
    },
    { key: 'entry_type_label', label: 'Type', sort_key: 'type' },
    {
      key: 'amount_text',
      label: 'Amount',
      align: 'right',
      sort_key: 'amount',
      render: (r) => (
        <WhyPopover
          detail={r.explain}
          amount_node={<span className={r.amount_tone}>{r.amount_text}</span>}
        />
      )
    },
    { key: 'entry_at_text', label: 'Date / time (IST)', sort_key: 'date' },
    { key: 'note', label: 'Note', render: (r) => <span title={r.note}>{r.note || '—'}</span> },
    { key: 'reference_id', label: 'Ref', render: (r) => r.reference_id || '—' },
    {
      key: 'source_label',
      label: 'Source',
      sort_key: 'source',
      render: (r) => (
        <StatusPill tone={r.is_system_posted ? 'blue' : 'gray'}>{r.source_label}</StatusPill>
      )
    },
    {
      key: 'added_text',
      label: 'Added by / at',
      sort_key: 'added_by',
      render: (r) => <span title={r.added_by_title}>{r.added_text}</span>
    },
    {
      key: 'status',
      label: 'Status',
      sort_key: 'status',
      render: (r) => (
        <span>
          <StatusPill tone={r.is_removed ? 'red' : 'green'}>{r.status_label}</StatusPill>
          {r.reversed_text ? <div className="tp-card-field-label">{r.reversed_text}</div> : null}
          {r.is_removed && !r.reversed_text && r.removed_at_text ? (
            <div className="tp-card-field-label" title={r.remove_reason}>
              Removed by <span title={r.removed_by_title}>{r.removed_by_text}</span> ·{' '}
              {r.removed_at_text}
            </div>
          ) : null}
        </span>
      )
    },
    { key: 'actions', label: 'Actions', hideInCard: true, render: actions_cell }
  ];

  return (
    <DataTable
      columns={columns}
      rows={rows}
      rowKey={(r) => r.key}
      rowClassName={(r) => (highlight_uuid && r.uuid === highlight_uuid ? 'tp-row-hl' : '')}
      emptyText="No additional payments for this month and filter."
      cardTitle={(r) => (
        <span>
          {r.teacher_name}
          <span className={`${r.amount_tone} tp-card-amt`}>{r.amount_text}</span>
          {r.is_removed ? <StatusPill tone="red">{r.status_label}</StatusPill> : null}
          {actions_cell(r)}
        </span>
      )}
      sort={sort}
      on_sort={on_sort}
    />
  );
};

export default EntriesTable;
